<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >人员列表</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入姓名、邮箱或部门"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="总部"
                            field="headquarter"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.headquarter"
                                    :options="toolbar.hqOptions"
                                    placeholder="全部"
                                    clearable
                                    transfer
                                    style="width: 140px"
                                ></vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="管理员"
                            field="isAdmin"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.isAdmin"
                                    placeholder="全部"
                                    style="width: 80px"
                                >
                                    <vxe-option
                                        value=""
                                        label="全部"
                                    ></vxe-option>
                                    <vxe-option
                                        value="1"
                                        label="是"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="是否在职"
                            field="accountStatus"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.accountStatus"
                                    placeholder="全部"
                                    style="width: 80px"
                                >
                                    <vxe-option value="" label="全部"></vxe-option>
                                    <vxe-option value="1" label="是"></vxe-option>
                                    <vxe-option value="0" label="否"></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                                <vxe-button status="success" @click="addUser"
                                    >新增</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                        ref="xTable"
                    >
                        <vxe-column
                            type="seq"
                            field="Uid"
                            title="序号"
                            width="60"
                        ></vxe-column>
                        <vxe-column
                            type="text"
                            field="Id"
                            title="id"
                            :visible="false"
                            width="80"
                        ></vxe-column>
                        <vxe-column
                            field="UserName"
                            title="姓名"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="empCode"
                            title="工号"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="accountStatus"
                            title="是否在职"
                            width="100"
                            sortable
                        >
                            <template #default="{ row }">
                                <span v-if="row.accountStatus == '1'">是</span>
                                <span v-else-if="row.accountStatus == '0'">否</span>
                                <span v-else>-</span>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="PositionName"
                            title="岗位"
                            width="120"
                            sortable
                            resizable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="JobZb"
                            title="总部"
                            width="80"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="JobName"
                            title="部门"
                            width="80"
                            sortable
                            resizable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="UserMail"
                            title="邮箱"
                            width="200"
                            sortable
                            resizable
                            show-overflow
                        ></vxe-column>
                        <vxe-column title="角色" width="80">
                            <template #default="{ row }">
                                <span v-if="row.isAdmin == '1'">管理员</span>
                                <span v-else>用户</span>
                            </template>
                        </vxe-column>
                        <vxe-column title="Tableau管理员" width="120">
                            <template #default="{ row }">
                                <span v-if="row.isTableauAdmin == '1'">是</span>
                                <span v-else>否</span>
                            </template>
                        </vxe-column>
                        <vxe-column title="Teambition管理员" width="140">
                            <template #default="{ row }">
                                <span v-if="row.isTeambitionAdmin == '1'"
                                    >是</span
                                >
                                <span v-else>否</span>
                            </template>
                        </vxe-column>
                        <vxe-column title="修改密码" width="80" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-expeditedssl"
                                    @click="editEventPwd(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column title="编辑" width="80" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-edit"
                                    @click="editEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column title="删除" width="80" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-trash-o"
                                    @click="removeEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column title="密钥操作" width="120" show-overflow>
                            <template #default="{ row }">
                                <vxe-button type="text" @click="createKey(row)"
                                    >生成</vxe-button
                                >
                                <vxe-button type="text" @click="copyKey(row)"
                                    >复制</vxe-button
                                >
                            </template>
                        </vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
            <!-- 新增-->
            <vxe-modal
                v-model="formInput.isShow"
                @close="findData"
                :title="formInput.title"
                width="500"
                height="600"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <vxe-form
                        :data="formInput.formData"
                        :rules="formInput.formRules"
                        title-align="right"
                        ref="nForm"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="基本信息"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-address-card-o' }"
                        ></vxe-form-item>
                        <vxe-form-item
                            title="UID"
                            field="uid"
                            span="24"
                            title-width="140px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.uid"
                                    placeholder="请输入UID"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="姓名"
                            field="UserName"
                            span="24"
                            title-width="140px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.UserName"
                                    placeholder="请输入姓名"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="总部"
                            field="JobZb"
                            span="24"
                            title-width="140px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.JobZb"
                                    placeholder="请输入总部"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="部门"
                            field="JobName"
                            span="24"
                            title-width="140px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.JobName"
                                    placeholder="请输入部门"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="邮箱"
                            field="UserMail"
                            span="24"
                            title-width="140px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.UserMail"
                                    placeholder="请输入邮箱"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="管理员"
                            field="isAdmin"
                            span="24"
                            title-width="140px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.isAdmin"
                                    placeholder="请选择管理员"
                                    clearable
                                >
                                    <vxe-option
                                        value="0"
                                        label="否"
                                    ></vxe-option>
                                    <vxe-option
                                        value="1"
                                        label="是"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="Tableau管理员"
                            field="isAdmin"
                            span="24"
                            title-width="140px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.isTableauAdmin"
                                    placeholder="请选择管理员"
                                    clearable
                                >
                                    <vxe-option
                                        value="0"
                                        label="否"
                                    ></vxe-option>
                                    <vxe-option
                                        value="1"
                                        label="是"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="Teambition管理员"
                            field="isAdmin"
                            span="24"
                            title-width="140px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="
                                        formInput.formData.isTeambitionAdmin
                                    "
                                    placeholder="请选择管理员"
                                    clearable
                                >
                                    <vxe-option
                                        value="0"
                                        label="否"
                                    ></vxe-option>
                                    <vxe-option
                                        value="1"
                                        label="是"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="远程桌面查看"
                            field="canView"
                            span="24"
                            title-width="140px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.canView"
                                    placeholder="请选择远程桌面查看"
                                    clearable
                                >
                                    <vxe-option
                                        value="0"
                                        label="否"
                                    ></vxe-option>
                                    <vxe-option
                                        value="1"
                                        label="是"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="远程桌面控制"
                            field="canControl"
                            span="24"
                            title-width="140px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.canControl"
                                    placeholder="请选择远程桌面控制"
                                    clearable
                                >
                                    <vxe-option
                                        value="0"
                                        label="否"
                                    ></vxe-option>
                                    <vxe-option
                                        value="1"
                                        label="是"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item align="center" span="24">
                            <template #default>
                                <vxe-button
                                    @click="save"
                                    icon="fa fa-save"
                                    status="success"
                                    >保存
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
            </vxe-modal>

            <!-- 修改密码-->
            <vxe-modal
                v-model="formPassword.isShow"
                :title="formPassword.title"
                width="500"
                height="340"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <vxe-form
                        :data="formPassword.formData"
                        :rules="formPassword.formRules"
                        title-align="right"
                        ref="nFormPwd"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="邮箱"
                            field="UserMail"
                            span="24"
                            title-width="140px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formPassword.formData.UserMail"
                                    readonly
                                    disabled
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="姓名"
                            field="UserName"
                            span="24"
                            title-width="140px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formPassword.formData.UserName"
                                    readonly
                                    disabled
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="新密码"
                            field="newPwd1"
                            span="24"
                            title-width="140px"
                        >
                            <template #default>
                                <vxe-input
                                    type="password"
                                    v-model="formPassword.formData.newPwd1"
                                    placeholder="请输入新密码"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="确认密码"
                            field="newPwd2"
                            span="24"
                            title-width="140px"
                        >
                            <template #default>
                                <vxe-input
                                    type="password"
                                    v-model="formPassword.formData.newPwd2"
                                    placeholder="请输入确认密码"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item align="center" span="24">
                            <template #default>
                                <vxe-button
                                    @click="savePwd"
                                    icon="fa fa-save"
                                    status="success"
                                    >保存
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
            </vxe-modal>
        </va-card-content>
    </va-card>
</template>

<script>
import Qs from "qs";
import { reactive } from "vue";
import { VXETable } from "vxe-table";

export default {
    name: "UserList",
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const toolbar = reactive({
            loading: false,
            hqOptions: [],
            formData: {
                searchKey: "",
                headquarter: "",
                isAdmin: "",
                accountStatus: "",
            },
        });
        const formInput = reactive({
            title: "新增用户",
            isShow: false,

            formData: {
                Id: "",
                UserName: "",
                UserPwd: "",
                JobName: "",
                UserMail: "",
                isAdmin: "",
                isTableauAdmin: "",
                isTeambitionAdmin: "",
                JobZb: "",
                Enable: "1",
                canView: "1",
                canControl: "0",
                headPic: "",
                uid: "",
            },
            formRules: {
                UserName: [{ required: true, message: "姓名不能为空" }],
                JobName: [{ required: true, message: "部门不能为空" }],
                UserMail: [{ required: true, message: "邮箱不能为空" }],
                UserEmail: [{ required: true, message: "业务人员不能为空" }],
                isAdmin: [{ required: true, message: "是否管理员不能为空" }],
                isTableauAdmin: [
                    { required: true, message: "是否Tableau管理员不能为空" },
                ],
                isTeambitionAdmin: [
                    { required: true, message: "是否Teambition管理员不能为空" },
                ],
                JobZb: [{ required: true, message: "总部不能为空" }],
                canView: [{ required: true, message: "远程桌面查看不能为空" }],
                canControl: [
                    { required: true, message: "远程桌面控制不能为空" },
                ],
                uid: [{ required: true, message: "UID不能为空" }],
            },
        });

        const formPassword = reactive({
            title: "修改密码",
            isShow: false,
            formData: {
                Id: "",
                UserName: "",
                UserMail: "",
                newPwd1: "",
                newPwd2: "",
            },
            formRules: {
                newPwd1: [{ required: true, message: "新密码不能为空" }],
                newPwd2: [{ required: true, message: "确认密码不能为空" }],
            },
        });

        return {
            tableData: null,
            tablePager,
            toolbar,
            pageHeight,
            formInput,
            editType: 1, //1 新增 2 编辑
            formPassword,
            tableHeight: 0,
        };
    },
    methods: {
        launchToast(toastMsg) {
            this.$vaToast.init({
                message: toastMsg,
                iconClass: this.toastIcon,
                position: this.toastPosition,
                duration: Number(this.toastDuration),
                fullWidth: this.isToastFullWidth,
            });
        },
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        findData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [
                    this.toolbar.formData.searchKey,
                    this.toolbar.formData.headquarter,
                    this.toolbar.formData.isAdmin,
                    "",
                    this.toolbar.formData.accountStatus,
                ],
            };
            this.$api.systemManageAPI
                .getUserList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindHeadquarters() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 50,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getHeadquarterList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.toolbar.hqOptions = res.data.Data.dataTable.map(
                        (item) => ({
                            value: item.hqCode,
                            label: item.hqName,
                        })
                    );
                })
                .catch((error) => {
                    VXETable.modal.message({
                        content: error,
                        status: "error",
                    });
                });
        },
        addUser() {
            this.formInput.formData = {
                Id: "",
                UserName: "",
                UserPwd: "",
                JobName: "",
                UserMail: "",
                isAdmin: "",
                isTableauAdmin: "",
                isTeambitionAdmin: "",
                JobZb: "",
                Enable: "1",
                canView: "1",
                canControl: "0",
                headPic: "",
                uid: "",
            };
            this.editType = 1;
            this.formInput.isShow = true;
        },
        //保存
        async save() {
            const $rForm = this.$refs.nForm;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                return;
            }
            const params = this.formInput.formData;
            if (this.editType == 1) {
                this.$api.systemManageAPI
                    .addUser(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "保存成功",
                            status: "success",
                        });
                        this.formInput.isShow = false;
                        this.findData();
                    })
                    .catch((error) => {
                        VXETable.modal.alert({
                            content: error,
                            status: "error",
                        });
                        console.log(error);
                    });
            } else {
                this.$api.systemManageAPI
                    .updateUser(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "保存成功",
                            status: "success",
                        });
                        this.formInput.isShow = false;
                        this.findData();
                    })
                    .catch((error) => {
                        VXETable.modal.alert({
                            content: error,
                            status: "error",
                        });
                        console.log(error);
                    });
            }
        },
        //编辑
        editEvent(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: [row.Id],
            };
            this.$api.systemManageAPI
                .getUserOne(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.formInput.formData = res.data.Data;
                    if (this.formInput.formData.isAdmin == 1) {
                        this.formInput.formData.isAdmin = "1";
                    } else {
                        this.formInput.formData.isAdmin = "0";
                    }
                    if (this.formInput.formData.isTableauAdmin == 1) {
                        this.formInput.formData.isTableauAdmin = "1";
                    } else {
                        this.formInput.formData.isTableauAdmin = "0";
                    }
                    if (this.formInput.formData.isTeambitionAdmin == 1) {
                        this.formInput.formData.isTeambitionAdmin = "1";
                    } else {
                        this.formInput.formData.isTeambitionAdmin = "0";
                    }
                    this.editType = 2;
                    this.formInput.isShow = true;
                    this.formInput.title = "编辑用户";
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //编辑密码
        editEventPwd(row) {
            this.formPassword.formData.Id = row.Id;
            this.formPassword.formData.UserName = row.UserName;
            this.formPassword.formData.UserMail = row.UserMail;
            this.formPassword.formData.newPwd1 = "";
            this.formPassword.formData.newPwd2 = "";
            this.formPassword.isShow = true;
        },
        //保存密码
        async savePwd() {
            const $rForm = this.$refs.nFormPwd;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                return;
            }
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: [
                    this.formPassword.formData.newPwd1,
                    this.formPassword.formData.newPwd2,
                    this.formPassword.formData.Id,
                ],
            };

            this.$api.systemManageAPI
                .changeUserPwd(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    VXETable.modal.message({
                        content: "修改密码成功",
                        status: "success",
                    });
                    this.formPassword.isShow = false;
                })
                .catch((error) => {
                    VXETable.modal.alert({ content: error, status: "error" });
                    console.log(error);
                });
        },
        //删除用户
        async removeEvent(row) {
            const type = await VXETable.modal.confirm("您确定要删除该数据?");
            const $grid = this.$refs.xTable;
            if (type === "confirm") {
                const param = {
                    id: row.Id,
                };
                this.$api.systemManageAPI
                    .delUser(Qs.stringify(param))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "删除成功",
                            status: "success",
                        });
                        $grid.remove(row);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        //生成密码
        async createKey(row) {
            const type = await VXETable.modal.confirm(
                "您确定要生成资产加密密钥吗?"
            );

            if (type === "confirm") {
                const param = {
                    id: row.Id,
                };
                this.$api.systemManageAPI
                    .createCryptKey(Qs.stringify(param))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "密钥生成成功",
                            status: "success",
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        copyKey(row) {
            navigator.clipboard.writeText(row.cryptKey).then(
                () => {
                    VXETable.modal.message({
                        content: "密钥复制成功",
                        status: "success",
                    });
                },
                (err) => {
                    VXETable.modal.message({
                        content: "密钥复制失败",
                        status: "error",
                    });
                    console.error("Could not copy text: ", err);
                }
            );
        },
        handlePageChange() {
            this.findData();
        },
        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.headquarter = "";
            this.toolbar.formData.isAdmin = "";
            this.toolbar.formData.accountStatus = "";
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
    },
    mounted() {
        this.bindHeadquarters();
        this.findData();
        window.addEventListener("keydown", this.keydown);
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
};
</script>

<style lang="scss">
.markup-tables {
    .table-wrapper {
        overflow: auto;
    }

    .va-table {
        width: 100%;
    }
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
